import React, {useState} from 'react';
import {Mutation} from '@apollo/react-components';
import {InscriptionMutation} from "../apollo/mutations/InscriptionMutation";
import InscriptionForm from "./InscriptionForm";
import CiberAlerts, {MESSAGES} from "../util/Messages";
import Spinner from "react-bootstrap/Spinner";
import FinalStep from "./FinalStep";
import ModalDateCorrection from "./ModalDateCorrection";
import {getLoggedUser} from "../util/Utils";


export default class InscriptionMain extends React.Component {
  state = {
    dataInscription: {},
    dataCorrection: {},
    readyToSend: false,
    errorMessage: null,
    showModal: false,
    contactPhone: '',
    age: '',
    contactName: '',
    date: new Date(),
    toInscription: true,
    finalStep: false
  };

  callbackFunction = (inscription) => {
    this.setState({
      errorMessage: ''
    });
    if (inscription.child && inscription.institution && inscription.grade && inscription.affiliate) {
      let loggedUser = getLoggedUser();
      this.setState({
        dataInscription: {
          affiliateDocType: inscription.affiliate.documentType,
          affiliateDocument: inscription.affiliate.documentNumber,
          beneficiaryDocType: inscription.child.value.documentType,
          beneficiaryDocument: inscription.child.value.documentNumber,
          institutionId: inscription.institution.value.institutionId,
          scheduleId: inscription.institution.value.scheduleId,
          levelId: inscription.grade.value.levelId,
          programId: inscription.grade.value.programId,
          degreeId: inscription.grade.value.degreeId,
          birthDate: inscription.child.value.birthDate,
          beneficiaryName: inscription.child.value.name,
          affiliateName: inscription.affiliate.name,
          affiliateLastName: inscription.affiliate.lastName,
          beneficiaryLastName: inscription.child.value.lastName,
          deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1)),
          uuid: loggedUser?loggedUser.UID:null
        },
        dataCorrection: {
          affiliateDocType: inscription.affiliate.documentType,
          affiliateDocument: inscription.affiliate.documentNumber,
          beneficiaryDocType: inscription.child.value.documentType,
          beneficiaryDocument: inscription.child.value.documentNumber,
          institutionId: inscription.institution.value.institutionId,
          scheduleId: inscription.institution.value.scheduleId,
          birthDate: inscription.child.value.birthDate,
          contact: '',
          phoneContact: '',
          beneficiaryName: inscription.child.value.name,
          affiliateName: inscription.affiliate.name,
          affiliateLastName: inscription.affiliate.lastName,
          beneficiaryLastName: inscription.child.value.lastName,
          deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1))
        },
        readyToSend: true,
      });
    }
    else{
      this.setState({
        readyToSend: false,
      });
    }

  };

  onChange = date => this.setState({date});


  callbackErrorFunction = (error) => {
    if (!this.state.errorMessage) {
      setTimeout(
        function () {
          this.setState({
            errorMessage: error
          });
        }.bind(this),
        200
      );
    }
  };

  setError(error) {
    this.setState({
      errorMessage: error
    });
  }

  openModal() {
    this.setState({
      showModal: true
    });
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  handleChangeContact = (e) => {
      this.setState({
        [e.target.name]: e.target.value
      });
  };

  render() {
    return (
      <Mutation mutation={InscriptionMutation}
        variables={{dataInscription: this.state.toInscription ? this.state.dataInscription : this.state.dataCorrection}}
        onError={(error) => {
          this.setError(error)
        }}>
        {(enrollSon, result) => {
          const {data, loading} = result;
          const [show, setShow] = useState(false);
          const handleClose = () => setShow(false);
          const handleShow = () => setShow(true);


          if (data && data.saveInscription && data.saveInscription.statusCode === "CIB-GEN-0200") {
            if (data.saveInscription.redirectUrl) {
              window.location.replace(data.saveInscription.redirectUrl)
            } else {
              return <FinalStep message={MESSAGES["SUCCESS"]} title="Inscripción a Cibercolegios"/>
            }
          }

          const confirmDate = () => {
            handleClose();
            let newDateCorrection = this.state.dataCorrection;
            newDateCorrection.birthDate = this.state.date;
            newDateCorrection.contact= this.state.contactName;
            newDateCorrection.phoneContact= this.state.contactPhone;
            this.setState({
              errorMessage: '',
              dataCorrection: newDateCorrection,
              toInscription: false
            }, () => {
              enrollSon()
            });

          };

          return (
            <>
              <div className="card card-signin my-5 col-sm-6 border-left-0">
                <div className="card-body">
                  <h1 className="card-title text-center">Inscripción a Cibercolegios </h1>
                  {this.state.errorMessage ?
                    <CiberAlerts error={this.state.errorMessage} callBack={handleShow}/> :
                    null
                  }
                  <div className="alert alert-primary justify-content-md-end d-flex text-justify" role="alert">
                    {MESSAGES.NOTE_COLSUBSIDIO}
                  </div>
                  <InscriptionForm parentCallback={this.callbackFunction} errorCallBack={this.callbackErrorFunction}/>
                  <button className="btn btn-lg btn-primary btn-block" type="submit"
                    disabled={!this.state.readyToSend}
                    onClick={enrollSon}>Diligenciar Inscripción
                    {loading ? <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner> : ""}
                  </button>
                  <br/>
                  <div className="alert alert-primary justify-content-md-end d-flex text-justify" role="alert">
                    * Si el beneficiario no se encuentra en el listado, por favor comuníquese a la línea de
                    Audioservicios Colsubsidio 7457900 opciones 2-4-2 o acérquese al Centro de Servicios más
                    cercano.
                  </div>
                  <ModalDateCorrection
                    show={show}
                    handleClose={handleClose}
                    withContactInfo={true}
                    date={this.state.date}
                    onChange={this.onChange}
                    contactName={this.state.contactName}
                    contactPhone={this.state.contactPhone}
                    callBack={confirmDate}
                    onChangeContact={this.handleChangeContact}
                  />
                </div>
              </div>
            </>
          );
        }}
      </Mutation>
    );
  }
}
